import {DiscreteColorPalette} from 'analysis-tool/ui/charting/ChartingTypes';

export const COLOR_PALETTES: Record<DiscreteColorPalette, Array<string>> = {
  BENCHLING: [
    '#000DB5',
    '#D74B4B',
    '#E79F10',
    '#00B553',
    '#DAF972',
    '#3C65FB',
    '#B50000',
    '#EAC76C',
    '#0C8697',
    '#A2B9BE',
    '#5293FF',
    '#FF7280',
    '#FFCB90',
    '#90DED6',
    '#C9E4EB',
    '#6BA1FF',
    '#FF949F',
    '#CA4F28',
    '#57AFC2',
    '#E5BFEE',
    '#7387CF',
    '#FFCF52',
    '#8B271C',
    '#67B897',
    '#B459B6',
    '#B5C5FF',
    '#5F44AD',
    '#879CA0',
    '#8ACFCB',
    '#3C5A62',
  ],
  DARK24: [
    '#2e91e5',
    '#e15f99',
    '#1ca71c',
    '#fb0d0d',
    '#da16ff',
    '#222a2a',
    '#b68100',
    '#750d86',
    '#eb663b',
    '#511cfb',
    '#00a08b',
    '#fb00d1',
    '#fc0080',
    '#b2828d',
    '#6c7c32',
    '#778aae',
    '#862a16',
    '#a777f1',
    '#620042',
    '#1616a7',
    '#da60ca',
    '#6c4516',
    '#0d2a63',
    '#af0038',
  ],
  LIGHT24: [
    '#fd3216',
    '#00fe35',
    '#6a76fc',
    '#fed4c4',
    '#fe00ce',
    '#0df9ff',
    '#f6f926',
    '#ff9616',
    '#479b55',
    '#eea6fb',
    '#dc587d',
    '#d626ff',
    '#6e899c',
    '#00b5f7',
    '#b68e00',
    '#c9fbe5',
    '#ff0092',
    '#22ffa7',
    '#e3ee9e',
    '#86ce00',
    '#bc7196',
    '#7e7dcd',
    '#fc6955',
    '#e48f72',
  ],
  BOLD: [
    '#7f3c8d',
    '#11a579',
    '#3969ac',
    '#f2b701',
    '#e73f74',
    '#80ba5a',
    '#e68310',
    '#008695',
    '#cf1c90',
    '#f97b72',
    '#a5aa99',
  ],
  PASTEL: [
    '#66c5cc',
    '#f6cf71',
    '#f89c74',
    '#dcb0f2',
    '#87c55f',
    '#9eb9f3',
    '#fe88b1',
    '#c9db74',
    '#8be0a4',
    '#b497e7',
    '#b3b3b3',
  ],
  SAFE: [
    '#88ccee',
    '#cc6677',
    '#ddcc77',
    '#117733',
    '#332288',
    '#aa4499',
    '#44aa99',
    '#999933',
    '#882255',
    '#661100',
    '#888888',
  ],
  PRISM: [
    '#5f4690',
    '#1d6996',
    '#38a6a5',
    '#0f8554',
    '#73af48',
    '#edad08',
    '#e17c05',
    '#cc503e',
    '#94346e',
    '#6f4070',
    '#666666',
  ],
};
